import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e6d304e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mainContainer",
  class: "main_container"
}
const _hoisted_2 = {
  ref: "textDiv",
  class: "textDiv"
}
const _hoisted_3 = { class: "main-top" }
const _hoisted_4 = { class: "main_title" }
const _hoisted_5 = { class: "header-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "white-space"
}
const _hoisted_8 = { class: "top_container" }
const _hoisted_9 = { class: "clubdeal_title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caution_container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "join_character",
    src: "/assets/image/join_character.png",
    srcset: "/assets/image/join_character@2x.png 2x,/assets/image/join_character@3x.png 3x"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "caution_message" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "blue_text" }, " 잠깐! "),
    /*#__PURE__*/_createTextVNode(" 클럽딜의 특성을 이해한 후,"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 동의하시면 참여하세요. ")
  ])
], -1))
const _hoisted_11 = { class: "ion-activatable ripple-parent check-container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check_content" }, "참여금 전액 손실 등 매우 큰 위험을 감수합니다.", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail_message" }, " 스타트업의 주식 보유로 매우 큰 차익실현을 기대할 수 있지만, 비상장회사 주식투자의 특성을 이해하고 참여금 전액 손실 등 매우 큰 위험을 감수합니다. ", -1))
const _hoisted_15 = { class: "ion-activatable ripple-parent check-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check_content" }, "참여금액은 조합이 공동 관리해야 합니다.", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail_message" }, " 클럽딜 참여시 참여한 금액의 투자 대상은 조합원 자격으로서 투자대상 회사의 주식 그 자체가 아닙니다. 설립되는 조합이 주식을 매수하게 되며, 개인은 조합원 자격을 보유하게 됩니다. ", -1))
const _hoisted_19 = { class: "ion-activatable ripple-parent check-container" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check_content" }, "개인의 출자금 회수는 조합이 해산되어야 가능합니다.", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "detail_message" }, " 기업공개(IPO)나 인수합병(M&A)을 통해 조합이 해산된 후에 개인 출자금 회수를 기대할 수 있습니다. 다만 비상장주식의 특성상 유동성이 작아 회수가 어려울 가능성도 있습니다. ", -1))
const _hoisted_23 = { class: "top_container" }
const _hoisted_24 = { class: "one_container" }
const _hoisted_25 = { class: "clubdeal_title" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail_message" }, " 본 위험고지서는 귀하가 (주)엔젤리그가 운영하는 서비스 위에서, 업무집행조합원과 함께 조합에 참여하여 조합을 공동경영하기 전에 출자의 위험을 사전에 충분히 인지할 수 있도록 (주)엔젤리그가 귀하에게 고지하는 내용입니다. ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "agree_content" }, "내용을 확인했습니다.", -1))
const _hoisted_28 = { class: "check_circle" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail_document" }, [
  /*#__PURE__*/_createElementVNode("ol", { class: "detail_list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "귀하의 투자대상은 조합의 지분으로서 투자대상회사의 주식 그 자체가 아닙니다. 설립되는 조합이 비상장주식을 매수하게 되며 귀하는 그 조합의 지분을 보유하게 됩니다."),
    /*#__PURE__*/_createElementVNode("li", null, "조합의 업무집행조합원 및 다른 조합원은 귀하와 조합의 동업자로서, 조합 출자재산의 운영 및 배분은 조합원 전원의 합의로 이루어지고, 업무집행조합원은 조합의 출자재산을 운용하지 않습니다."),
    /*#__PURE__*/_createElementVNode("li", null, "조합의 투자대상인 투자대상회사의 증권은 원금손실의 위험성이 있으며, 투자한 자금의 원금을 회수할 수 없음에 따른 손실의 위험이 있음을 이해합니다. 또한 귀하가 예상하거나 기대하는 수익의 일부 또는 전부를 얻지 못할 수 있습니다."),
    /*#__PURE__*/_createElementVNode("li", null, "귀하는 (주)엔젤리그의 홈페이지에 게재된 투자대상회사에 대한 설명 투자대상회사의 증권 매수조건, 투자대상회사의 증권 매수 시점 및 가격의 내부 의사결정방법, 업무집행조합원의 성과보수, 업무집행조합원의 역할, 투자위험요소 등을 충분히 확인하였습니다."),
    /*#__PURE__*/_createElementVNode("li", null, "귀하는 (주)엔젤리그는 업무집행조합원이 안전하고 쉽게 조합을 만드는 것을 도와주는 역할만 수행하므로 투자손실의 위험을 보전하는 당사자가 아님을 확인합니다. 조합의 업무집행조합원 역시 귀하와 같이 조합을 설립하고 운영하는 동업자로서 투자손실의 위험을 보전하는 당사자가 아님을 확인합니다. 즉, 투자에 대한 모든 위험은 본인에게 있음을 확인합니다."),
    /*#__PURE__*/_createElementVNode("li", null, "귀하는 조합을 통해 매수하는 투자대상회사의 비상장증권은 한국거래소의 상장을 목적으로 하는 것이 아니며, 따라서 증권의 환금성에 큰 제약이 있다는 점과 예상 회수금액에 대한 일부 혹은 전부를 회수할 수 없는 위험이 있음을 이해하며, 귀하가 이를 감당할 수 있음을 확인합니다."),
    /*#__PURE__*/_createElementVNode("li", null, "귀하는 시장의 상황, 제도의 변경이 있을 수 있으며, 자본시장법 등 관련법규에 근거하여 투자의 한도에 제한이 있는 경우 이를 준수하여야 함을 이해합니다."),
    /*#__PURE__*/_createElementVNode("li", null, "귀하는 귀하가 보유한 조합의 지분에 대하여 원칙적으로 1년간 전매가 제한된다는 점을 이해합니다.")
  ])
], -1))
const _hoisted_31 = { class: "top_container" }
const _hoisted_32 = { class: "two_container" }
const _hoisted_33 = { class: "clubdeal_title" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact_info" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "성명, 생년월일, 주소(상세주소 제외), 참여금액"),
  /*#__PURE__*/_createTextVNode("은 조합 규약 작성을 위하여 조합원 간에는 불가피하게 공유됩니다. ")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "agree_content" }, "동의합니다.", -1))
const _hoisted_36 = { class: "check_circle" }
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact_info" }, [
  /*#__PURE__*/_createTextVNode(" 아래 "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "계약서"),
  /*#__PURE__*/_createTextVNode(" 내용을 확인하시면,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 추후 내용변경 없이 동의하실 수 있도록 "),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "동일 내용으로 계약서가 발송됩니다.")
], -1))
const _hoisted_39 = {
  class: "check_circle",
  src: "/assets/icon/check_circle_s@3x.png"
}
const _hoisted_40 = { class: "red" }
const _hoisted_41 = { class: "detail_document" }
const _hoisted_42 = { class: "short_dash_list" }
const _hoisted_43 = { class: "top_container" }
const _hoisted_44 = { class: "three_container" }
const _hoisted_45 = { class: "clubdeal_title" }
const _hoisted_46 = { class: "number_container" }
const _hoisted_47 = { class: "number_info" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" 참여 가능 금액")
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = { class: "input_number" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "0", -1))
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = { class: "input_number" }
const _hoisted_55 = { class: "strong" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_57 = { class: "deal_info" }
const _hoisted_58 = { class: "space-between" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_left gray" }, " 주당 가격 ", -1))
const _hoisted_60 = { class: "info_right" }
const _hoisted_61 = { class: "bold" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_63 = { class: "space-between" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_left gray" }, " 주식 수 ", -1))
const _hoisted_65 = { class: "info_right" }
const _hoisted_66 = { class: "bold" }
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" 주 ")
const _hoisted_68 = { class: "pad-container" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "row" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "clear" }, "00", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "0", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/backspace@3x.png",
    class: "backSpace",
    alt: "backspace"
  })
], -1))
const _hoisted_74 = { class: "top_container" }
const _hoisted_75 = { class: "four_top" }
const _hoisted_76 = { class: "clubdeal_title" }
const _hoisted_77 = { class: "price_info" }
const _hoisted_78 = { class: "space-between" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_left" }, " 참여 금액 ", -1))
const _hoisted_80 = { class: "info_right" }
const _hoisted_81 = { class: "bold" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_83 = { class: "space-between" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_left" }, " 서비스 이용료 ", -1))
const _hoisted_85 = { class: "info_right" }
const _hoisted_86 = { class: "bold" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_88 = { class: "point_box" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "regular bold" }, " 엔젤리그 Point 사용 ", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "point_info" }, " 서비스 이용료를 Point로 지불할 수 있습니다. ", -1))
const _hoisted_91 = { class: "user_point" }
const _hoisted_92 = { class: "space-between" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "point_left" }, " 보유 ", -1))
const _hoisted_94 = { class: "regular strong" }
const _hoisted_95 = { class: "space-between" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "point_left" }, " 사용 ", -1))
const _hoisted_97 = { class: "info_container" }
const _hoisted_98 = { class: "adjust-btn" }
const _hoisted_99 = { class: "point-value" }
const _hoisted_100 = { class: "result_container" }
const _hoisted_101 = { class: "result_top space-between" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result_left" }, " 입금할 금액 ", -1))
const _hoisted_103 = { class: "result_right extra-large" }
const _hoisted_104 = { class: "blue" }
const _hoisted_105 = { class: "strong" }
const _hoisted_106 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_107 = { class: "result_content" }
const _hoisted_108 = { class: "space-between" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result_left" }, " 주당 가격 ", -1))
const _hoisted_110 = { class: "result_right" }
const _hoisted_111 = { class: "strong" }
const _hoisted_112 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_113 = { class: "space-between" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result_right" }, " 구매 주식 수 ", -1))
const _hoisted_115 = { class: "result_right" }
const _hoisted_116 = { class: "strong" }
const _hoisted_117 = /*#__PURE__*/_createTextVNode(" 주 ")
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service_info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info_title" }, " 서비스의 내용 "),
  /*#__PURE__*/_createElementVNode("ul", { class: "dash_list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "조합 규약의 제공 및 조합 설립의 대행"),
    /*#__PURE__*/_createElementVNode("li", null, "세무서 신고 및 고유번호증 신청 대행"),
    /*#__PURE__*/_createElementVNode("li", null, "매매계약 및 명의개서절차 대행"),
    /*#__PURE__*/_createElementVNode("li", null, "조합의 운영 및 관리 지원"),
    /*#__PURE__*/_createElementVNode("li", null, "기타 위 사항들에 부수하는 사항")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "info_title" }, " 환불 정책 "),
  /*#__PURE__*/_createElementVNode("ul", { class: "dash_list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "회원이 조합참여를 확정한 후 단순 변심으로 인한 환불은 10만원, 조합규약 발송 이후에는 20만원을 환불 수수료로 공제한 금액을 환불합니다."),
    /*#__PURE__*/_createElementVNode("li", null, "회원이 조합참여를 확정한 후 회사가 지정한 기한 내에 조합 참여금액에 수수료를 더한 금액의 전부 또는 일부를 입금하지 않는 경우 회사는 회원의 이용신청을 거절하고 입금금액 전부를 환불할 수 있습니다."),
    /*#__PURE__*/_createElementVNode("li", null, "회원이 조합참여를 확정한 후 조합 규약을 전자서명 한 이후에는 환불이 불가능합니다."),
    /*#__PURE__*/_createElementVNode("li", null, "포인트로 지급한 이용료는 포인트로 환급합니다.")
  ])
], -1))
const _hoisted_119 = { class: "top_container" }
const _hoisted_120 = { class: "four_top" }
const _hoisted_121 = { class: "clubdeal_title" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result_info extra-large bold" }, [
  /*#__PURE__*/_createTextVNode(" 아래 내용으로"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "참여를 확정"),
  /*#__PURE__*/_createTextVNode("합니다. ")
], -1))
const _hoisted_123 = { class: "result_content" }
const _hoisted_124 = { class: "space-between" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_left" }, " 참여 금액 ", -1))
const _hoisted_126 = { class: "info_right" }
const _hoisted_127 = { class: "strong" }
const _hoisted_128 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_129 = { class: "space-between" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_left" }, " 서비스 이용료 ", -1))
const _hoisted_131 = { class: "info_right" }
const _hoisted_132 = { class: "strong" }
const _hoisted_133 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_134 = { class: "space-between" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_left" }, " 입금할 금액 ", -1))
const _hoisted_136 = { class: "info_right extra-large blue" }
const _hoisted_137 = { class: "strong" }
const _hoisted_138 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_139 = { class: "result_content" }
const _hoisted_140 = { class: "space-between" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_left" }, " 주당 가격 ", -1))
const _hoisted_142 = { class: "info_right" }
const _hoisted_143 = { class: "strong" }
const _hoisted_144 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_145 = { class: "space-between" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_left" }, " 구매 주식 수 ", -1))
const _hoisted_147 = { class: "info_right" }
const _hoisted_148 = /*#__PURE__*/_createTextVNode(" 주 ")
const _hoisted_149 = { class: "top_container" }
const _hoisted_150 = { class: "six_top" }
const _hoisted_151 = { class: "clubdeal_title" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result_info extra-large bold" }, " 참여 확정! 입금 대기 ", -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "final_content" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "blue" }, [
    /*#__PURE__*/_createTextVNode(" 입금 가능 기한 내에 아래 계좌로 참여 금액을 입금해주세요. 단, "),
    /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "목표금액 조기 달성시 선착순 입금순"),
    /*#__PURE__*/_createTextVNode("으로 참여가 완료됩니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 입금이 늦어 참여가 철회되지 않게 서둘러주세요! ")
  ])
], -1))
const _hoisted_154 = { class: "final_info" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "final_title gray" }, " 입금계좌 ", -1))
const _hoisted_156 = { class: "space-between" }
const _hoisted_157 = { class: "large bold" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "copy_btn",
  src: "/assets/icon/copy.png",
  srcset: "/assets/icon/copy@2x.png 2x,/assets/icon/copy@3x.png 3x"
}, null, -1))
const _hoisted_160 = [
  _hoisted_159
]
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "final_title gray" }, " 입금금액 ", -1))
const _hoisted_162 = { class: "space-between" }
const _hoisted_163 = { class: "large" }
const _hoisted_164 = { class: "bold" }
const _hoisted_165 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "final_title gray" }, " 입금 가능 기한 ", -1))
const _hoisted_167 = { class: "space-between" }
const _hoisted_168 = { class: "large bold" }
const _hoisted_169 = { class: "footer_container space-between" }
const _hoisted_170 = ["disabled"]
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "다음", -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "다음", -1))
const _hoisted_173 = ["disabled"]
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "참여 확정", -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "완료. 입금계좌 복사", -1))
const _hoisted_176 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        id: "clubDealOpenJoinIonContent",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, null, 512),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.curStep !== 6)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "ion-activatable ripple-parent btn-back",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'헤더', 'clickContent':'뒤로가기'});_ctx.dismiss('clubDealOpenJoinModal')})
                      }, [
                        _hoisted_6,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ]))
                    : (_ctx.curStep === 6)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                      : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("span", null, "참여 위험안내", 512), [
                    [_vShow, _ctx.curStep == 0 || _ctx.curStep == 1]
                  ]),
                  _withDirectives(_createElementVNode("span", null, "조합규약(계약서) 동의", 512), [
                    [_vShow, _ctx.curStep == 2]
                  ]),
                  _withDirectives(_createElementVNode("span", null, "참여 금액 입력", 512), [
                    [_vShow, _ctx.curStep == 3]
                  ]),
                  _withDirectives(_createElementVNode("span", null, "참여 금액 확인", 512), [
                    [_vShow, _ctx.curStep == 4]
                  ]),
                  _withDirectives(_createElementVNode("span", null, "참여 확정 정보", 512), [
                    [_vShow, _ctx.curStep == 5]
                  ]),
                  _withDirectives(_createElementVNode("span", null, "참여 정보", 512), [
                    [_vShow, _ctx.curStep == 6]
                  ])
                ])
              ]),
              _createVNode(_component_ion_progress_bar, { value: _ctx.gauge }, null, 8, ["value"])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.partnershipName) + " 열기 ", 1),
              _hoisted_10,
              _createElementVNode("label", _hoisted_11, [
                _createElementVNode("input", {
                  id: "0",
                  type: "checkbox",
                  value: "true",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'동의', 'clickContent':`참여금 전액 손실 등 매우 큰 위험을 감수합니다.`});_ctx.checkForm($event.target)})
                }),
                _hoisted_12,
                _hoisted_13,
                _hoisted_14,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _createElementVNode("label", _hoisted_15, [
                _createElementVNode("input", {
                  id: "1",
                  type: "checkbox",
                  value: "true",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'동의', 'clickContent':`참여금액은 조합지분으로 공동 관리해야 합니다.`});_ctx.checkForm($event.target)})
                }),
                _hoisted_16,
                _hoisted_17,
                _hoisted_18,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _createElementVNode("label", _hoisted_19, [
                _createElementVNode("input", {
                  id: "2",
                  type: "checkbox",
                  value: "true",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'동의', 'clickContent':`개인의 조합지분 양도는 조합 설립 1년 후부터 가능합니다.`});_ctx.checkForm($event.target)})
                }),
                _hoisted_20,
                _hoisted_21,
                _hoisted_22,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ])
            ], 512), [
              [_vShow, _ctx.curStep == 0]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.partnershipName) + " 열기 ", 1),
                _hoisted_26
              ]),
              _createElementVNode("div", {
                class: "ion-activatable ripple-parent agree_container",
                onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'참여 위험안내', 'clickContent':`내용을 확인했습니다`});(_ctx.nextToggle = !_ctx.nextToggle)})
              }, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("img", {
                    src: _ctx.nextToggle ? '/assets/icon/check_circle_s@3x.png' : '/assets/icon/check_circle_n@3x.png'
                  }, null, 8, _hoisted_29)
                ]),
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _hoisted_30
            ], 512), [
              [_vShow, _ctx.curStep == 1]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.partnershipName) + " 열기 ", 1),
                _hoisted_34,
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent contract_container",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'조합규약(계약서) 동의', 'clickContent':`동의합니다`});_ctx.agreeFunc()})
                }, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("img", {
                      src: _ctx.confirmToggle ? '/assets/icon/check_circle_s@3x.png' : '/assets/icon/check_circle_n@3x.png'
                    }, null, 8, _hoisted_37)
                  ]),
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ]),
                _hoisted_38
              ]),
              _createElementVNode("div", {
                class: "ion-activatable ripple-parent contract_view_container",
                onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'조합규약(계약서) 동의', 'clickContent':`계약서 전문 보기(필수)`});_ctx.createModal()})
              }, [
                _withDirectives(_createElementVNode("span", null, "계약서 확인 완료", 512), [
                  [_vShow, _ctx.contractToggle]
                ]),
                _withDirectives(_createElementVNode("img", _hoisted_39, null, 512), [
                  [_vShow, _ctx.contractToggle]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_40, "계약서 전문 보기 (필수)", 512), [
                  [_vShow, !_ctx.contractToggle]
                ]),
                _withDirectives(_createVNode(_component_ion_icon, {
                  class: "red ion-float-end",
                  icon: _ctx.chevronForwardOutline
                }, null, 8, ["icon"]), [
                  [_vShow, !_ctx.contractToggle]
                ]),
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_41, [
                _createElementVNode("ul", _hoisted_42, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investmentContractSummaries, (content, inx) => {
                    return (_openBlock(), _createElementBlock("li", { key: inx }, _toDisplayString(content), 1))
                  }), 128))
                ])
              ], 512), [
                [_vShow, _ctx.investmentContractSummaries]
              ])
            ], 512), [
              [_vShow, _ctx.curStep == 2]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.partnershipName) + " 열기 ", 1),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _hoisted_49,
                    _createTextVNode(" " + _toDisplayString(_ctx.currency(_ctx.investRangeFrom)) + "원 ~ " + _toDisplayString(_ctx.currency(_ctx.investRangeTo)) + "원 ", 1)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_50, _hoisted_53, 512), [
                    [_vShow, _ctx.investMoney === 0]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_54, [
                    _createElementVNode("span", {
                      class: _normalizeClass({'blue' : _ctx.investMoneyStatus ==='stable', 'red' : _ctx.investMoneyStatus === 'over' || _ctx.investMoneyStatus === 'lack'})
                    }, [
                      _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$filters.currency(_ctx.investMoney)), 1),
                      _hoisted_56
                    ], 2)
                  ], 512), [
                    [_vShow, _ctx.investMoney !== 0]
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$filters.currency(_ctx.stockPerPrice)), 1),
                        _hoisted_62
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.$filters.currency(_ctx.stockCount)), 1),
                        _hoisted_67
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0,1,2], (row) => {
                      return _createElementVNode("div", {
                        key: row,
                        class: "row"
                      }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (col) => {
                          return _createElementVNode("div", {
                            key: col,
                            class: "ion-activatable ripple-parent letter",
                            onClick: ($event: any) => (_ctx.addNumber(row * 3 + col))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(row * 3 + col), 1),
                            _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                          ], 8, _hoisted_69)
                        }), 64))
                      ])
                    }), 64)),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent letter",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addNumber('00')))
                      }, [
                        _hoisted_71,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ]),
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent letter",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addNumber(0)))
                      }, [
                        _hoisted_72,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ]),
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent letter",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearNumber('del')))
                      }, [
                        _hoisted_73,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ])
                    ])
                  ])
                ])
              ])
            ], 512), [
              [_vShow, _ctx.curStep == 3]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.partnershipName) + " 열기 ", 1),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$filters.currency(_ctx.investMoney)), 1),
                      _hoisted_82
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _hoisted_84,
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.$filters.currency(_ctx.serviceFee)), 1),
                      _hoisted_87
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _hoisted_89,
                _hoisted_90,
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    _hoisted_93,
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.curPoint)) + " P", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_95, [
                    _hoisted_96,
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", {
                          class: "btn",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'엔젤리그 Point 사용', 'clickContent':`-`});_ctx.adjustPoint(_ctx.usePoint-10000)})
                        }, " - "),
                        _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.$filters.currency(_ctx.usePoint)) + " P ", 1),
                        _createElementVNode("div", {
                          class: "btn",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'엔젤리그 Point 사용', 'clickContent':`+`});_ctx.adjustPoint(_ctx.usePoint+10000)})
                        }, " + ")
                      ]),
                      _createElementVNode("div", {
                        class: "all-btn",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'엔젤리그 Point 사용', 'clickContent':`전액사용`});_ctx.adjustPoint(_ctx.initPoint, 'all')})
                      }, " 전액사용 ")
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _hoisted_102,
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("span", _hoisted_104, [
                      _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.$filters.currency(_ctx.finalPrice)), 1),
                      _hoisted_106
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, [
                    _hoisted_109,
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.$filters.currency(_ctx.stockPerPrice)), 1),
                      _hoisted_112
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_113, [
                    _hoisted_114,
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.$filters.currency(_ctx.stockCount)), 1),
                      _hoisted_117
                    ])
                  ]),
                  _hoisted_118
                ])
              ])
            ], 512), [
              [_vShow, _ctx.curStep == 4]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_119, [
              _createElementVNode("div", _hoisted_120, [
                _createElementVNode("div", _hoisted_121, _toDisplayString(_ctx.partnershipName) + " 열기 ", 1),
                _hoisted_122,
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("div", _hoisted_124, [
                    _hoisted_125,
                    _createElementVNode("div", _hoisted_126, [
                      _createElementVNode("span", _hoisted_127, _toDisplayString(_ctx.$filters.currency(_ctx.investMoney)), 1),
                      _hoisted_128
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_129, [
                    _hoisted_130,
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("span", _hoisted_132, _toDisplayString(_ctx.$filters.currency(_ctx.serviceFee)), 1),
                      _hoisted_133
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_134, [
                    _hoisted_135,
                    _createElementVNode("div", _hoisted_136, [
                      _createElementVNode("span", _hoisted_137, _toDisplayString(_ctx.$filters.currency(_ctx.finalPrice)), 1),
                      _hoisted_138
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_139, [
                  _createElementVNode("div", _hoisted_140, [
                    _hoisted_141,
                    _createElementVNode("div", _hoisted_142, [
                      _createElementVNode("span", _hoisted_143, _toDisplayString(_ctx.$filters.currency(_ctx.stockPerPrice)), 1),
                      _hoisted_144
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_145, [
                    _hoisted_146,
                    _createElementVNode("div", _hoisted_147, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.stockCount)), 1),
                      _hoisted_148
                    ])
                  ])
                ])
              ])
            ], 512), [
              [_vShow, _ctx.curStep == 5]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_149, [
              _createElementVNode("div", _hoisted_150, [
                _createElementVNode("div", _hoisted_151, _toDisplayString(_ctx.partnershipName) + " 열기 ", 1),
                _hoisted_152,
                _hoisted_153,
                _createElementVNode("div", _hoisted_154, [
                  _hoisted_155,
                  _createElementVNode("div", _hoisted_156, [
                    _createElementVNode("div", _hoisted_157, [
                      _createTextVNode(_toDisplayString(_ctx.depositInfo.bank) + " " + _toDisplayString(_ctx.depositInfo.bankno), 1),
                      _hoisted_158,
                      _createTextVNode(" " + _toDisplayString(_ctx.depositInfo.bankholder), 1)
                    ]),
                    _createElementVNode("div", {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'입금계좌', 'clickContent':`복사버튼`});_ctx.copyText(_ctx.account, 'copy')})
                    }, _hoisted_160)
                  ]),
                  _hoisted_161,
                  _createElementVNode("div", _hoisted_162, [
                    _createElementVNode("div", _hoisted_163, [
                      _createElementVNode("span", _hoisted_164, _toDisplayString(_ctx.$filters.currency(_ctx.depositInfo.asset)), 1),
                      _hoisted_165
                    ])
                  ]),
                  _hoisted_166,
                  _createElementVNode("div", _hoisted_167, [
                    _createElementVNode("div", _hoisted_168, _toDisplayString(_ctx.depositInfo.dueDate) + " 17:00 ", 1)
                  ])
                ])
              ])
            ], 512), [
              [_vShow, _ctx.curStep == 6]
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, {
        class: "ion-no-border",
        "no-padding": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_169, [
            _withDirectives(_createElementVNode("button", {
              class: "ion-activatable ripple-parent gray_btn footer_btn",
              onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단버튼', 'clickContent':`${_ctx.curStep == 0?'취소':'이전'}`});_ctx.previousProcess()})
            }, [
              _withDirectives(_createElementVNode("span", null, "취소", 512), [
                [_vShow, _ctx.curStep == 0]
              ]),
              _withDirectives(_createElementVNode("span", null, "이전", 512), [
                [_vShow, _ctx.curStep != 0]
              ]),
              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
            ], 512), [
              [_vShow, _ctx.curStep != 6]
            ]),
            (_ctx.curStep == 2)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "ion-activatable ripple-parent blue_btn footer_btn",
                  disabled: !_ctx.confirmToggle||!_ctx.contractToggle,
                  onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단버튼', 'clickContent':`다음`});_ctx.nextProcess()})
                }, [
                  _hoisted_171,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ], 8, _hoisted_170))
              : (_ctx.curStep == 4)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "ion-activatable ripple-parent blue_btn footer_btn",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단버튼', 'clickContent':`다음`});_ctx.nextProcess()})
                  }, [
                    _hoisted_172,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]))
                : (_ctx.curStep == 5)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "ion-activatable ripple-parent red_btn footer_btn",
                      disabled: _ctx.requested,
                      onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단버튼', 'clickContent':`참여확정`});_ctx.nextProcess()})
                    }, [
                      _hoisted_174,
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ], 8, _hoisted_173))
                  : (_ctx.curStep == 6)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "ion-activatable ripple-parent blue_btn footer_btn",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단버튼', 'clickContent':`완료. 입금계좌 복사`});_ctx.copyText(_ctx.account, 'quit')})
                      }, [
                        _hoisted_175,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ]))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        class: "ion-activatable ripple-parent blue_btn footer_btn",
                        disabled: !_ctx.nextToggle,
                        onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'하단버튼', 'clickContent':`${{0:'동의합니다', 1:'확인완료'}[_ctx.curStep]||'다음'}`});_ctx.nextProcess()})
                      }, [
                        _withDirectives(_createElementVNode("span", null, "동의합니다", 512), [
                          [_vShow, _ctx.curStep == 0]
                        ]),
                        _withDirectives(_createElementVNode("span", null, "확인완료", 512), [
                          [_vShow, _ctx.curStep == 1]
                        ]),
                        _withDirectives(_createElementVNode("span", null, "다음", 512), [
                          [_vShow, _ctx.curStep != 0 && _ctx.curStep != 1]
                        ]),
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ], 8, _hoisted_176))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}